import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowDown from '@/images/ArrowDown.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import Select from '@mui/material/Select';
import { ComponentProps } from 'react';

const StyledSelect = styled(Select)`
    border-radius: 8px;
    max-height: 32px !important;
    outline: none;
    position: relative;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 14px;
    width: 88px;
    padding: 6px;

    svg {
        position: absolute;
        right: 10px;
        min-width: 16px;
        pointer-events: none;
    }

    fieldset {
        border: ${({ theme }) => `1px solid ${theme.colors.black[200]}`} !important;
    }
`;

export const ControlSelect = (props: ComponentProps<typeof Select>) => {
    return (
        <StyledSelect
            {...props}
            sx={{
                '&:hover': {
                    backgroundColor: theme.colors.black[100],
                },
            }}
            MenuProps={{ sx: { maxHeight: '500px' } }}
            inputProps={{ sx: { padding: '0 24px 0 8px !important' } }}
            IconComponent={() => <MaskedIcon src={ArrowDown} size="16px" />}
        />
    );
};
